export const BD_GET_PACKAGING_LISTING = "BD_GET_PACKAGING_LISTING"
export const BD_GET_PACKAGING_LISTING_SUCCESS = "BD_GET_PACKAGING_LISTING_SUCCESS"
export const BD_GET_PACKAGING_LISTING_FAILED = "BD_GET_PACKAGING_LISTING_FAILED"
